// @flow
import React from "react"
import { StyledInput } from "componentsStyled/Forms/Input"
import { StyledWrap } from "./styled"

type Props = {|
  onChange: SyntheticInputEvent<*> => ?string,
  value: ?string,
|}

const PromocodeInput = ({ onChange, value }: Props) => (
  <StyledWrap>
    <StyledInput
      type="text"
      onChange={onChange}
      value={value}
      name="promocode"
      label="promocode"
      placeholder="Enter a promocode..."
    />
  </StyledWrap>
)

export default PromocodeInput



// WEBPACK FOOTER //
// ./src/modals/SubscribePlan/PromocodeInput/index.js